import { render } from "./_tag-card-actions-menu.vue?vue&type=template&id=2919e8d2&lang=pug"
import script from "./_tag-card-actions-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./_tag-card-actions-menu.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__